import { Box } from "@mui/material"

const ScenarioFileTableExample = () => {
  return (
    <Box
      component="table"
      sx={{
        width: "100%",
        "th, td": {
          border: "1px solid black",
          borderCollapse: "collapse",
        },
      }}
    >
      <thead style={{ textAlign: "left" }}>
        <tr>
          <th>Date</th>
          <th>Scenario</th>
          <th>Mnem</th>
          <th>Value</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>20250101</td>
          <td>Optimistic</td>
          <td>USA electricity price</td>
          <td>18.58322</td>
        </tr>
        <tr>
          <td>20260101</td>
          <td>Optimistic</td>
          <td>USA electricity price</td>
          <td>19.02553</td>
        </tr>
        <tr>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
        </tr>

        <tr>
          <td>20250101</td>
          <td>Pessimistic</td>
          <td>USA electricity price</td>
          <td>19.22893</td>
        </tr>
        <tr>
          <td>20260101</td>
          <td>Pessimistic</td>
          <td>USA electricity price</td>
          <td>20.16621</td>
        </tr>
        <tr>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
        </tr>
      </tbody>
    </Box>
  )
}

export default ScenarioFileTableExample
